module.exports = __webpack_public_path__ + "static/media/cool.2f18b3a7.svg";